// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebaseConfig: {
    apiKey: "AIzaSyBi-mI94whRK_BsInEM-FNE_gttCiBKE6A",
    authDomain: "pmu-beauty-forms.firebaseapp.com",
    databaseURL: "https://pmu-beauty-forms.firebaseio.com",
    projectId: "pmu-beauty-forms",
    storageBucket: "pmu-beauty-forms.appspot.com",
    messagingSenderId: "265429654619",
    appId: "1:265429654619:web:d63b84351986c62206b37e",
    measurementId: "G-JJMKD3JM75"
  },
  dataDogLoggerConfig: {
    clientToken: "pubd07e66e8bcd77f0e24092fd7d45f54ab",
    site: "datadoghq.com"
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
